import { z } from "zod";

import { EDataUnit } from "@/constants/data-units.type";
import {
  commonConsumptionSchema,
  wattHourValueSchema,
} from "@/data/api/kili/consumption/types/common-consumption.type";
import { dateRangeSchema } from "@/data/api/kili/consumption/types/temporal-metrics.type";

export const siteIdsQuerySchema = z.array(z.number()).min(1);

export const multisiteConsumptionRequestSchema = dateRangeSchema.extend({
  siteIds: siteIdsQuerySchema.nullish(),
});

const siteConsumptionSchema = z.object({
  siteId: z.number(),
  name: z.string(),
  consumption: wattHourValueSchema,
  lastPeriodConsumption: wattHourValueSchema,
  evolution: z.object({
    value: z.number().nullable(),
    unit: z.literal(EDataUnit.PERCENT),
  }),
  consumptionPerArea: wattHourValueSchema,
  consumptionCost: z.object({
    value: z.number().nullable(),
    unit: z.literal(EDataUnit.EURO),
  }),
  applianceCount: z.number().nullable(),
  sectionCount: z.number().nullable(),
});

const siteMissingConsumptionInfosSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const multisiteConsumptionMissingInfosSchema = z.object({
  missingPriceSites: z.array(siteMissingConsumptionInfosSchema),
  missingAreaSites: z.array(siteMissingConsumptionInfosSchema),
  missingAllDsoIndexSubscriptions: z.boolean(),
  missingSomeDsoIndexSubscriptions: z.boolean(),
});

export const multisiteConsumptionSchema = commonConsumptionSchema.extend({
  bySite: z.array(siteConsumptionSchema),
});

export type TMultisiteConsumptionRequest = z.infer<typeof multisiteConsumptionRequestSchema>;
export type TSiteConsumption = z.infer<typeof siteConsumptionSchema>;
export type TMultisiteMissingInfos = z.infer<typeof multisiteConsumptionMissingInfosSchema>;
export type TMultisiteConsumption = z.infer<typeof multisiteConsumptionSchema>;
export type TSiteIdsQuery = z.infer<typeof siteIdsQuerySchema>;
